import {game} from "../GameCore";

var spaceKey: Phaser.Key,
    touch: Phaser.Input;

/**
 * set up all interaction in the game
 * @param phaserGame
 */
export function addInteraction()
{
    //  add key listeners

    spaceKey = addKeyboardListeners();
}


/**
 * listen for keyboard interactions
 * @param phaserGame
 */
function addKeyboardListeners()
{
    var key: Phaser.Key;

    //  start listening for space bar presses

    key = game.input.keyboard.addKey(Phaser.Keyboard.SPACEBAR);

    //  capture spacebar presses, preventing them from propagating

    game.input.keyboard.addKeyCapture([Phaser.Keyboard.SPACEBAR ]);

    //  return the key

    return key;
}


/**
 * add touch input listeners
 */
function addTouchListeners()
{

}


/**
 * check whether the user wants to crouch, increasing speed and preparing to jump
 */
export function userWantsToCrouch() : boolean
{
    return spaceKey.isDown || game.input.activePointer.isDown;
}





///**
// * listen for touch interactions
// */
//function addTouchListeners()
//{
//
//}
//
//
///**
// *
// * @returns {boolean}
// */
//export function userIsCrouching() : boolean
//{
//    return spaceKey.isDown;
//}


// WEBPACK FOOTER //
// ./src/ts/game/input/Interaction.ts